import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { mainTransition } from 'ggApp/modules/router/actions';

import Page500 from './Page500';

const enchance = compose(
    connect(null, (dispatch) => ({
        mainTransition: bindActionCreators(mainTransition, dispatch),
    })),
);

export default enchance(Page500);
